import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CategoryService } from '../../../category/services/category.service';
import { Photo } from '../../../../shared/models/cameralla-photo.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CategoryModel } from '../../../../shared/models/cameralla-category.model';
import { debounceTime, filter } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import * as $ from 'jquery';
import { PhotoOrder } from '../../../../shared/models/cameralla-photo-order.model';
import { Location } from '@angular/common';
import { GlobalVariables } from '../../../../shared/models/cameralla-global.model';
import { UserService } from '../../../user/services/user.service';
import { CamerallaUser } from '../../../../shared/models/cameralla-user.model';
import { CamerallaAuthService } from '../../../../shared/services/authentication-services/cameralla-auth.service';
import { BannerManagementComponent } from '../../../administrator/banner-management/banner-management';
import { HttpClient } from '@angular/common/http';
import * as  _ from 'underscore';
import { NgxMasonryOptions } from 'ngx-masonry';
import { FilterDefaultModel } from '../../../../shared/models/cameralla-filter-default.model';
import { FilterPhotoForm } from '../../../administrator/filter-photo-form/filter-photo-form';
import AppShareHelper from '../../../../shared/utils/helper';
import { ConfigService } from "../../../../shared/services/config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl } from "@angular/forms";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { AdvertisingService } from "../../../../shared/services/advertising.service";
import { GroupService } from "../../../user/services/group.service";
import { VideoService } from "../../../photo/services/video.service";
import { PermissionAdminService } from "../../../../shared/services/guard-services/permission-admin.service";
import { UploadVideoService } from "../../../upload/service/upload-video.service";
import {PartnerService} from "../../../../shared/services/partner.service";

declare var jQuery: any;

@Component({
  templateUrl: './video.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
  ],
})
export class VideoComponent implements OnInit, AfterViewInit, OnDestroy {
  static readonly maxWidthMobile = 991;
  @ViewChild('datepickerFilter') datePickerElement;

  goldenPhotoFormControl = new FormControl(null);

  vipTabActive = false;
  limit = 10;
  skip = 0;
  popupType = 'popup';
  videos = [];
  previousPhotos: Photo[] = [];
  newPhotos = 0;
  photoOrder: PhotoOrder;
  filters: CategoryModel[] = [];
  currentAds: any = false;
  advertisementPhoto = [
  ];
  filterMonth;
  isAdmin = false;
  searchTerm = '';
  testingMode = false;
  goldenPhotoFilter = false;
  public activeQuickFilter: any = {};
  selectedFilters = [];
  arrayFilterOption: FilterDefaultModel[] = [];
  lazyLoadTriggered = true;
  _srolling: Subscription;
  loaded = false;
  userId: number;
  partnerRoute: string;
  userProfile: CamerallaUser;
  homeRoute = GlobalVariables.HOME_ROUTE;
  membershipTags;
  partnerObjects = GlobalVariables.partnerObjects;
  partnerNavigators = GlobalVariables.partnerNavigators;
  partnerInfo: any = {
    BannerUrl: '',
    BannerMobileUrl: '',
    LogoUrl: '',
    Title: '',
    Welcome: '',
    Slogan: '',
    Content: '',
    BannerArr: [],
    BannerMobileArr: [],
  };
  defaultFilter: any = {
    tags: [],
    searchText: '',
    categories: []
  };
  isFavorite = false;
  active = true;
  today = new Date();
  vipMember = null;
  userGroups = []
  groupId = null;

  public renderImageOptions: NgxMasonryOptions = {
    transitionDuration: '1s',
    itemSelector: '.grid-item',
    horizontalOrder: true
  };

  routeSubscription: Subscription;

  @ViewChild('photoZone') photoZone;

  constructor(private videoService: VideoService,
              private categoryService: CategoryService,
              private configService: ConfigService,
              private router: Router,
              private route: ActivatedRoute,
              protected _modalService: NgbModal,
              private location: Location,
              private userService: UserService,
              public advertisingService: AdvertisingService,
              private authService: CamerallaAuthService,
              private http: HttpClient,
              private groupService: GroupService,
              private uploadVideoService: UploadVideoService,
  ) {
    this.photoOrder = new PhotoOrder();
    this.userId = +this.authService.getLocalUserInfo()['id'];
  }

  ngOnInit() {
    if (localStorage.getItem('navigateFromDetailPage')) {
      this.renderImageOptions.transitionDuration = '0s';
    }

    this.userService.getUserInformation(this.userId).then(
      (resolve: any[]) => {
        this.isAdmin = (resolve[0].role == PermissionAdminService.adminConst);
        this.vipMember = AppShareHelper.checkVipMember(resolve[0].accessLevel);
        this.membershipTags = (resolve[0].memberships[0]).toLowerCase();
        this.userProfile = Object.assign(resolve[0], resolve[1]);
      }
    );

    this.advertisingService.getAdvertising(null, true, true).toPromise().then((resAds:any) => {
      if (resAds.Data.length) {
        resAds.Data.forEach(ads => {
          this.advertisementPhoto.push({
            original: ads.bannerUrl,
            thumbnail: ads.bannerThumbUrl,
            tags: ads.tags,
            navigateUrl: ads.navigateUrl,
            partnerId: ads.partnerId,
            id : ads.id + new Date().getTime(),
            rawId : ads.id,
            type : 'advertisings',
            height : 300,
            width: 300
          });
        })
      }
    })
    
    this.routeSubscription = this.router.events.pipe(
      filter(routeEvent => routeEvent instanceof NavigationEnd),
    ).subscribe((routeEvent: any) => {
      // Only action if this home belongs to the right partner that has been routed to.
      this.active = false;


      if (routeEvent.url === '/videos') {
        this.active = true;
        const scrollPosition = localStorage.getItem('video-scrollPosition');

        if (this.uploadVideoService.deletedPhotoId) {
          for (let i = 0; i < this.videos.length; i++) {
            if (this.videos[i].id == this.uploadVideoService.deletedPhotoId) {
              this.videos.splice(i, 1);
              break;
            }
          }

          this.uploadVideoService.deletedPhotoId = null;
        }

        setTimeout(() => {
          this.updateMansoryLayout();
        });

        if (scrollPosition) {
          setTimeout(() => {
            $(window).scrollTop(scrollPosition);
            setTimeout(() => {
              this.lazyLoadTriggered = true;
            }, 150);
          }, 600);
        }
      } else {
        this.lazyLoadTriggered = false;
        this.active = false;
      }
    });

    this.route.params.subscribe(
      params => {
        localStorage.removeItem('navigateFromDetailPage');

        this.vipTabActive = this.route.snapshot['_routerState'].url === GlobalVariables.MEMBER_ONLY;

        let urlFilterApi = FilterPhotoForm.filterAPI;
        this.groupId = null;
        this.partnerRoute = params['partner'] || (this.vipTabActive ? 'vip' : this.homeRoute);

        this.http.get(urlFilterApi)
          .subscribe(
            (res: any) => {
              if (res.Data) {
                this.arrayFilterOption = [];
                if (res.Data && res.Data.defaultFilters && res.Data.defaultFilters.length) {
                  res.Data.defaultFilters.forEach((filterModel) => {
                    this.arrayFilterOption.push({
                      display: filterModel.text,
                      value: filterModel,
                      readonly: true,
                      class: '',
                      partner: filterModel.partner,
                      isDropdown: filterModel.isDropdown,
                      dropDownList: filterModel.dropDownList,
                      tags: filterModel.tags
                    });
                  });
                }}});

        if (!this.active) {
          return;
        }

        if (this.groupId) {
          GlobalVariables.CURRENT_PARTNER = {
            value: 'group',
            id: this.groupId,
          };
          this.getPartnerDetail(PartnerService.partnerAPI +  'group/' + this.groupId);
        } else {
          // Get partnerInfo
          this.partnerNavigators.forEach((partner: any) => {
            const me = this;
            if (partner.value === me.partnerRoute) {
              GlobalVariables.CURRENT_PARTNER = partner;
              me.photoOrder.selectedPartner = partner;
              this.getPartnerDetail(PartnerService.partnerAPI + partner.id);
            }
          });
        }
      }
    );
  }

  private getPartnerDetail(url) {
    this.http.get(url)
      .subscribe(
        (res: any) => {
          if (res.Data) {
            // Change http to https of the banner image.
            this.partnerInfo.BannerUrl = ((res.Data.banner && res.Data.banner.includes('http:') && !res.Data.banner.includes('https:'))) ?
              res.Data.banner.replace('http', 'https') : res.Data.banner;
            this.partnerInfo.BannerMobileUrl = ((res.Data.bannerMobile && res.Data.bannerMobile.includes('http:') && !res.Data.banner.includes('https:'))) ?
              res.Data.bannerMobile.replace('http', 'https') : res.Data.bannerMobile;
            this.partnerInfo.LogoUrl = res.Data.logo;
            this.partnerInfo.Title = res.Data.title;
            this.partnerInfo.Slogan = res.Data.slogan;
            this.partnerInfo.Welcome = res.Data.welcome;
            this.partnerInfo.BannerNavigateUrl = res.Data.bannerNavigateUrl;
            this.partnerInfo.Content = res.Data.content;
            this.partnerInfo.BannerArr = Array.isArray(res.Data.bannerArr) ? res.Data.bannerArr : [];
            this.partnerInfo.BannerMobileArr = Array.isArray(res.Data.bannerMobileArr) ? res.Data.bannerMobileArr : [];
          }
        },
        (error) => {
        }
      );
  }

  public activeFilter(filter, position) {
    this.searchTerm = '';
    this.selectedFilters = [];
    this.skip = 0;

    if (position != null) {
      filter.value.childPostion = position;
    }
    localStorage.setItem(this.videoService.convertPartnerString('activeFilter'), JSON.stringify(filter));
    localStorage.removeItem(this.videoService.convertPartnerString('selectedFilter'));

    if (this.activeQuickFilter.value && filter.value.id == this.activeQuickFilter.value.id
      && !filter.value.active ) { // filter.value.active - just for case golden photo filter
      if (filter.isDropdown) {
        $(`#child-item-filter-${filter.value.id} > button.active`).removeClass('active');
        if (!this.arraysMatch(this.activeQuickFilter.tags, filter.dropDownList[position])) {
          $(`#child-item-filter-${filter.value.id}`).children().eq(position).addClass('active');
          this.activeQuickFilter.tags = filter.dropDownList[position];
        } else {
          this.arrayFilterOption.forEach((item: any) => {
            item.class = '';
          });
          this.activeQuickFilter = {};
          localStorage.removeItem(this.videoService.convertPartnerString('activeFilter'));
        }
      } else {
        this.activeQuickFilter = {};
        this.arrayFilterOption.forEach((item: any) => {
          item.class = '';
        });
        localStorage.removeItem(this.videoService.convertPartnerString('activeFilter'));
      }
    } else {
      this.arrayFilterOption.forEach((item: any) => {
        if (item.value.id == filter.value.id) {
          item.class = 'active';
          if (typeof (filter.value.childPostion) != 'undefined' && filter.value.childPostion != null) {
            setTimeout(() => {
              $(`#child-item-filter-${filter.value.id}`).children().eq(filter.value.childPostion).addClass('active');
            }, 100);
          }
        } else {
          item.class = '';
          if (item.isDropdown) {
            $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
          }
        }
      });
      this.activeQuickFilter = Object.assign({}, filter);

      if (filter.isDropdown) {
        $(`#child-item-filter-${filter.value.id}`).children().eq(position).addClass('active');
        this.activeQuickFilter.tags = filter.dropDownList[position];
        if (typeof (filter.value.childPostion) != 'undefined' && filter.value.childPostion != null) {
          this.activeQuickFilter.tags = filter.dropDownList[filter.value.childPostion];
        }
      }
    }

    localStorage.removeItem('navigateFromDetailPage');
    this.lazyLoadTrigger();
  }

  public checkSizeWindowMobile() {
    return screen.width <= VideoComponent.maxWidthMobile;
  }

  arraysMatch(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; arr1.length < i; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  resetFilters() {
    this.limit = 10;
    this.skip = 0;
    this.selectedFilters = [];
    this.lazyLoadTriggered = true;
  }

  getCategories() {
    return this.categoryService.getCategories().toPromise().then(
      response => {
        if (response['Data']) {
          return Promise.resolve(response['Data']);
        }
      },
      error => {
        console.log('GET CATEGORY ERROR ' + error);
        Promise.reject(error);
      }
    );
  }

  getVideos(filterList: any[], photoOrder: PhotoOrder, limit, skip, defaultFilter, searchTerm?) {
    return this.videoService.getVideosByOrder(filterList, photoOrder, limit, skip, null, this.isFavorite, defaultFilter).toPromise().then(
      response => {
        if (response['IsSuccess']) {
          if (!response['Data'].length) {
            this.lazyLoadTriggered = false;
          }

          const result = response['Data'];

          return Promise.resolve(result);
        }

        return Promise.resolve([]);
      },
      error => {
        console.log('GET VIDEO API ERROR' + error);
        return Promise.reject(false);
      }
    );
  }

  selectFilter(category: CategoryModel) {
    this.previousPhotos = this.videos;
    this.activeQuickFilter = {};
    localStorage.removeItem(this.videoService.convertPartnerString('activeFilter'));

    this.arrayFilterOption.forEach((item: any) => {
      item.class = '';
      if (item.isDropdown) {
        $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
      }
    });

    this.lazyLoadTriggered = true;
    const selected_tag = {display: category.name, value: category.id};

    const isSelected = this.selectedFilters.some(each => {
      return each['value'] === selected_tag['value'];
    });

    if (!isSelected) {
      this.selectedFilters.push({display: category.name, value: category.id});
      this.videoService.publish(VideoService.SET_PHOTOS_FILTER);
    } else {
      this.selectedFilters = _.filter(this.selectedFilters, (item: any) => {
        return item.value != category.id;
      });
      this.removeFilter();
    }

    localStorage.setItem(this.videoService.convertPartnerString('selectedFilter'), JSON.stringify(this.selectedFilters));
  }

  search() {
    this.activeQuickFilter = {};
    localStorage.removeItem(this.videoService.convertPartnerString('activeFilter'));
    this.arrayFilterOption.forEach((item: any) => {
      item.class = '';
      if (item.isDropdown) {
        $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
      }
    });
    this.lazyLoadTrigger();
  }

  selectType(type) {
    this.isFavorite = type;
    this.resetFilters();
    localStorage.removeItem(this.videoService.convertPartnerString('selectedFilter'));
    localStorage.setItem('selectedType', JSON.stringify(type));
    this.activeQuickFilter = {};
    this.arrayFilterOption.forEach((item: any) => {
      item.class = '';
      if (item.isDropdown) {
        $(`#child-item-filter-${item.value.id} > button.active`).removeClass('active');
      }
    });
    this.lazyLoadTrigger();
  }

  selectOrder(order: { name: string, value: string }) {
    localStorage.setItem('selectedOrder', JSON.stringify(order));
    this.photoOrder.selectedOrder = order;
    this.lazyLoadTrigger();
  }

  removeFilter() {
    this.location.replaceState('/');
    this.lazyLoadTrigger();
  }

  isSelected(filter) {
    for (const each of this.selectedFilters) {
      if (each['value'] === filter['id']) {
        return true;
      }
    }

    return false;
  }

  trackByFn(index, item) {
    return item.id;
  }

  ngAfterViewInit() {
    this.getCategories().then(
      resolve => {
        this.filters = resolve;

        this.videoService.subscribe(VideoService.SET_PHOTOS_FILTER, () => {
          if (!this.active) {
            return;
          }
          this.skip = 0;

          // Set order descending is default
          this.photoOrder.selectedOrder = {name: 'Descending', value: 'DESC'};
          this.getVideos(this.selectedFilters, this.photoOrder, this.limit, this.skip, {}, this.searchTerm).then(
            resolve => {
              this.videos = resolve;

              if (resolve && resolve.length == 10) {
                const adsPhoto = this.getAdvertisingPhotos(this.skip);
                if (adsPhoto) {
                  this.videos.push(adsPhoto);
                }
              }

              this.updateMansoryLayout();
              this.newPhotos = this.videos.length - AppShareHelper.checkLoadedPhotos(this.previousPhotos, this.videos);
            },
            reject => console.log(reject)
          );
        });

        this.videoService.subscribe(VideoService.LAZY_LOADING_PHOTOS, (skip) => {
          if (!this.active) {
            return;
          }

          this.getVideos(this.selectedFilters, this.photoOrder, this.limit, skip, {}, this.searchTerm).then(
            resolve => {
              let dif = this.videos.length;

              this.videos.push(...resolve);

              // Remove duplicate photos
              this.videos = this.removeDuplicates(this.videos, 'id', 'advertisings');

              if (resolve && resolve.length == 10) {
                const adsPhoto = this.getAdvertisingPhotos(this.skip);
                if (adsPhoto) {
                  this.videos.push(adsPhoto);
                }
              }

              dif++;
              this.updateMansoryLayout();

              this.newPhotos += this.videos.length - dif;
            },
            reject => {
              console.log(reject);
            }
          );
        });

        setTimeout(function () {
          $('.dropdown-menu').click(function (e) {
            e.stopPropagation();
          });
        }, 0);

        this.loaded = true;

        this.route.queryParams.subscribe(
          params => {
            if (params['category']) {
              const category = this.filters.find((el: CategoryModel) => el.name === params['category']);
              this.selectFilter(category);
            } else {
              this.resetFilters();
              if (localStorage.getItem('navigateFromDetailPage')) {
                if (!localStorage.getItem('selectedType')) {
                  localStorage.setItem('selectedType', '1');
                }

                if (localStorage.getItem(this.videoService.convertPartnerString('activeFilter'))) {
                  this.activeFilter(JSON.parse(localStorage.getItem(this.videoService.convertPartnerString('activeFilter'))), null);
                } else {
                  this.renderVideos(this.selectedFilters, {}, null, this.searchTerm);
                }
              } else {
                this.renderVideos(this.selectedFilters, {}, null, this.searchTerm);
              }

            }
          }
        );
      },
      reject => console.log(reject)
    );

    this._srolling = fromEvent(document, 'scroll').pipe(debounceTime(300))
      .subscribe(
        events => {
          if (!this.active) {
            return;
          }

          const bottom = $(document).height();
          const scrollPosition = Math.ceil($(window).scrollTop() + $(window).height());

          if (this.lazyLoadTriggered) {
            if (scrollPosition + 100 >= bottom || (this.checkSizeWindowMobile() && scrollPosition + 420 >= bottom)) {
              this.skip += 10;
              this.lazyLoadTriggered = false;
              if (this.activeQuickFilter.value) {
                this.renderVideos(this.defaultFilter.categories, this.defaultFilter, true);
              } else {
                return this.videoService.publish(VideoService.LAZY_LOADING_PHOTOS, this.skip);
              }
            }

            return '';
          }

          return '';
        }
      );
  }

  ngOnDestroy() {
    this.skip = 0;
    this._srolling.unsubscribe();
    this.videoService.unsubscribe(VideoService.SET_PHOTOS_FILTER);
    this.videoService.unsubscribe(VideoService.LAZY_LOADING_PHOTOS);
    this.routeSubscription.unsubscribe();
  }

  resetPhotosList(searchKey: string) {
    const searchElement = document.getElementById('search_field');
    const isFocus = document.activeElement === searchElement;

    if (!searchKey && !isFocus) {
      this.resetFilters();
      return this.videoService.publish(VideoService.SET_PHOTOS_FILTER);
    }

    return '';
  }

  onNotify(lazyLoadReady: boolean) {
    this.lazyLoadTriggered = lazyLoadReady;
  }

  lazyLoadTrigger() {
    this.lazyLoadTriggered = true;

    if (this.activeQuickFilter.value) {
      this.defaultFilter.categories = [];
      if (this.activeQuickFilter.value.categoriesList.length > 0) {
        this.activeQuickFilter.value.categoriesList.forEach((item) => {
          this.defaultFilter.categories.push({display: item.name, value: item.id});
        });
      }

      this.defaultFilter.goldenPhotoFilter = false;
      this.defaultFilter.period = null
      this.defaultFilter.tags = this.activeQuickFilter.value.tags;
      this.goldenPhotoFormControl.setValue(null);

      if (this.activeQuickFilter.isDropdown) {
        this.defaultFilter.tags = this.activeQuickFilter.tags;
      }
      this.renderVideos(this.defaultFilter.categories, this.defaultFilter);
    } else {
      this.videoService.publish(VideoService.SET_PHOTOS_FILTER);
    }
  }

  public updateMansoryLayout() {
    setTimeout(() => {
      this.photoZone._msnry.reloadItems();
      this.photoZone._msnry.layout();
    }, 300);
  }

  public renderVideos(categoryFilter, defaultFilter, isPush?, searchTerm?) {
    this.getVideos(categoryFilter, this.photoOrder, this.limit, this.skip, defaultFilter, searchTerm).then(
      (resolve) => {
        if (isPush) {
          this.videos.push(...resolve);
        } else {
          this.videos = resolve;
        }

        // Remove the photo have specific tag when load data
        this.videos = this.removeDuplicates(this.videos, 'id', 'advertisings');

        if (resolve && resolve.length == 10) {

          const adsPhoto = this.getAdvertisingPhotos(this.skip);
          if (adsPhoto) {
            this.videos.push(adsPhoto);
          }
        }


        this.updateMansoryLayout();
        setTimeout(() => {
          this.photoZone._msnry.options.transitionDuration = '1s';
        }, 600);

      },
      reject => console.log(reject)
    );
  }

  clearSearchBox() {
    this.searchTerm = '';
    this.lazyLoadTrigger();
  }

  // Remove Duplicates photos
  removeDuplicates(myArr, prop, excludeType?) {
    return myArr.filter((obj, pos, arr) => {
      let condition = false;

      if (excludeType) {
        condition = obj.type == excludeType;
      }

      return (arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos) || condition;
    });
  }

  getAdvertisingPhotos(skip) {
    if (this.groupId) return false;
    const showAdsAfter = 20;
    const photoNumber = skip + 10;
    if (photoNumber % showAdsAfter == 0) {
      const page  = photoNumber/ showAdsAfter;

      if (!this.currentAds) { // cache filter ad photos
        this.currentAds = this.advertisementPhoto.filter( (el) => {
          return (el.partnerId == this.photoOrder.selectedPartner.id) &&
            (!el.tags || !el.tags.length || this.canShowAds(el.tags));
        });
      }

      let adsArr = this.currentAds ? this.currentAds : [];
      const length = adsArr.length;

      if (length) {
        return adsArr[((page - 1) % length)]
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getUserGroups() {
    this.groupService.getMyGroups(this.userId, 'joined').subscribe((groups: any) => {
      if (groups && groups.Data && groups.Data.length) {
        this.userGroups = groups.Data;
      }
    })
  }

  canShowAds(tags) {
    // filter ads by member tags
    let show = false;
    if (tags.length) {
      for (let i = 0; i < tags.length; i++) {
        show = this.membershipTags.includes(tags[i].toLowerCase());
        if (show) break;
      }
    }

    return show;
  }

  navigateToRankingList() {
    this.router.navigateByUrl('/user/golden-ranking');
  }
}
